import { useLayoutStore } from '@/store/pinia/layout'

export default {
  /** @param {import('vue').App} app - The Vue instance. */
  install (app) {
    app.mixin({
      watch: {
        $header: {
          handler (newValue) {
            const layoutStore = useLayoutStore()
            layoutStore.SET_HEADER(newValue)
          },
          deep: true,
        },
      },
      beforeCreate () {
        if (typeof this.$options.header !== 'function') return

        if (typeof this.$options.computed === 'undefined') {
          this.$options.computed = {}
        }
        this.$options.computed['$header'] = this.$options.header.bind(this)
      },
      async created () {
        if (typeof this.$options.header !== 'function') return
        if (this.$options.header.call(this) === null) return

        await this.$nextTick()
        const layoutStore = useLayoutStore()
        layoutStore.SET_HEADER(this.$header)
      },
      unmounted () {
        if (typeof this.$options.header === 'function') {
          if (this.$options.header.call(this) === null) return
          const layoutStore = useLayoutStore()
          layoutStore.SET_HEADER(null)
        }
      },
    })
  },
}
